import { Connection } from "./Connection.mjs";
import { Emitter } from "./util/Emitter.mjs";
export class Pool extends Emitter {
    constructor() {
        super();
        this.data = new Map();
    }
    has(url) {
        return this.data.has(url);
    }
    get(url, { autoConnect = true, reconnectAfter = 3000 } = {}) {
        let connection = this.data.get(url);
        if (autoConnect) {
            if (!connection) {
                connection = new Connection(url);
                this.data.set(url, connection);
                this.emit('init', connection);
                connection.on('open', () => this.emit('open', connection));
                connection.on('close', () => this.emit('close', connection));
            }
            connection.ensureConnected({
                shouldReconnect: connection.meta.lastClose < Date.now() - reconnectAfter,
            });
        }
        return connection;
    }
    remove(url) {
        const connection = this.data.get(url);
        if (connection) {
            connection.destroy();
            this.data.delete(url);
        }
    }
    clear() {
        for (const url of this.data.keys()) {
            this.remove(url);
        }
    }
}
//# sourceMappingURL=Pool.mjs.map